import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../context/auth.context";

import AuthPageLayout from "../components/layout/auth/authPage.layout";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const PublicRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (isLoading) return;

        return isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        ) : (
          <AuthPageLayout>
            <Component {...rest} />
          </AuthPageLayout>
        );
      }}
    />
  );
};

export default PublicRoute;
